// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/ai_color_simulation.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProcessImageParameters, ProcessImageType } from "../../ai_color_simulation/v1/messages_pb";
import { file_ai_color_simulation_v1_messages } from "../../ai_color_simulation/v1/messages_pb";
import type { AreaPresetSelection } from "./color_pb";
import { file_api_proto_v1_color } from "./color_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/ai_color_simulation.proto.
 */
export const file_api_proto_v1_ai_color_simulation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_ai_color_simulation_v1_messages, file_api_proto_v1_color, file_google_protobuf_timestamp]);

/**
 * @generated from message api_proto.v1.SimulatedColorSimulationImages
 */
export type SimulatedColorSimulationImages = Message<"api_proto.v1.SimulatedColorSimulationImages"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: ai_color_simulation.v1.ProcessImageType type = 3;
   */
  type: ProcessImageType;

  /**
   * 画像処理のパラメータ
   *
   * @generated from field: ai_color_simulation.v1.ProcessImageParameters parameters = 4;
   */
  parameters?: ProcessImageParameters;

  /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 5;
   */
  uploadedAt?: Timestamp;

  /**
   * @generated from field: bool favorited = 6;
   */
  favorited: boolean;

  /**
   * @generated from field: api_proto.v1.ColorSimulationImageCreatedByType created_by_type = 7;
   */
  createdByType: ColorSimulationImageCreatedByType;

  /**
   * シミュレーション実行者名
   *
   * @generated from field: string created_by_name = 8;
   */
  createdByName: string;

  /**
   * 履歴のタイトル（30文字まで）。未設定は空文字列。既定表示（日時　氏名）はフロントが組み立てる
   *
   * @generated from field: string title = 9;
   */
  title: string;

  /**
   * ピン留めした日時。未設定=ピン留めなし。昇順がピン留めした順
   *
   * @generated from field: google.protobuf.Timestamp pinned_at = 10;
   */
  pinnedAt?: Timestamp;

  /**
   * 表示用プレビュー（最大辺1280pxの縮小JPEG）のpresigned URL。画面表示・サムネイル用。DL・画像合成は url（原寸）を使う。未生成の旧データでは空。issue #2466
   *
   * @generated from field: string preview_url = 11;
   */
  previewUrl: string;
};

/**
 * Describes the message api_proto.v1.SimulatedColorSimulationImages.
 * Use `create(SimulatedColorSimulationImagesSchema)` to create a new message.
 */
export const SimulatedColorSimulationImagesSchema: GenMessage<SimulatedColorSimulationImages> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 0);

/**
 * @generated from message api_proto.v1.OriginalColorSimulationImages
 */
export type OriginalColorSimulationImages = Message<"api_proto.v1.OriginalColorSimulationImages"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: repeated api_proto.v1.SimulatedColorSimulationImages simulated_image = 3;
   */
  simulatedImage: SimulatedColorSimulationImages[];

  /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 4;
   */
  uploadedAt?: Timestamp;

  /**
   * @generated from field: bool favorited = 5;
   */
  favorited: boolean;

  /**
   * アップロードしたスタッフ名
   *
   * @generated from field: string created_by_name = 6;
   */
  createdByName: string;
};

/**
 * Describes the message api_proto.v1.OriginalColorSimulationImages.
 * Use `create(OriginalColorSimulationImagesSchema)` to create a new message.
 */
export const OriginalColorSimulationImagesSchema: GenMessage<OriginalColorSimulationImages> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 1);

/**
 * AIカラーシュミレーションの詳細を取得
 *
 * @generated from message api_proto.v1.GetDealWithColorSimulationResponse
 */
export type GetDealWithColorSimulationResponse = Message<"api_proto.v1.GetDealWithColorSimulationResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 staff_id = 2;
   */
  staffId: bigint;

  /**
   * @generated from field: string staff_name = 3;
   */
  staffName: string;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * @generated from field: string customer_name_full = 5;
   */
  customerNameFull: string;

  /**
   * @generated from field: string external_system_id = 6;
   */
  externalSystemId: string;

  /**
   * @generated from field: int64 customer_id = 7;
   */
  customerId: bigint;

  /**
   * @generated from field: string deal_name = 8;
   */
  dealName: string;

  /**
   * @generated from field: repeated api_proto.v1.OriginalColorSimulationImages images = 9;
   */
  images: OriginalColorSimulationImages[];
};

/**
 * Describes the message api_proto.v1.GetDealWithColorSimulationResponse.
 * Use `create(GetDealWithColorSimulationResponseSchema)` to create a new message.
 */
export const GetDealWithColorSimulationResponseSchema: GenMessage<GetDealWithColorSimulationResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 2);

/**
 * @generated from message api_proto.v1.GetDealWithColorSimulationListResponse
 */
export type GetDealWithColorSimulationListResponse = Message<"api_proto.v1.GetDealWithColorSimulationListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.GetDealWithColorSimulationResponse data = 1;
   */
  data: GetDealWithColorSimulationResponse[];

  /**
   * @generated from field: int64 total_page = 2;
   */
  totalPage: bigint;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;

  /**
   * @generated from field: double total_quotation_amount = 4;
   */
  totalQuotationAmount: number;

  /**
   * @generated from field: double total_contract_amount = 5;
   */
  totalContractAmount: number;

  /**
   * @generated from field: double total_complete_amount = 6;
   */
  totalCompleteAmount: number;
};

/**
 * Describes the message api_proto.v1.GetDealWithColorSimulationListResponse.
 * Use `create(GetDealWithColorSimulationListResponseSchema)` to create a new message.
 */
export const GetDealWithColorSimulationListResponseSchema: GenMessage<GetDealWithColorSimulationListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 3);

/**
 * マスク画像生成完了チェック用リクエスト
 *
 * @generated from message api_proto.v1.CheckMaskImagesReadyRequest
 */
export type CheckMaskImagesReadyRequest = Message<"api_proto.v1.CheckMaskImagesReadyRequest"> & {
  /**
   * 案件ID（互換性のため残す）
   *
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * 元画像ID（指定時はその画像のみチェック）
   *
   * @generated from field: int64 image_id = 2;
   */
  imageId: bigint;
};

/**
 * Describes the message api_proto.v1.CheckMaskImagesReadyRequest.
 * Use `create(CheckMaskImagesReadyRequestSchema)` to create a new message.
 */
export const CheckMaskImagesReadyRequestSchema: GenMessage<CheckMaskImagesReadyRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 4);

/**
 * マスク画像生成完了チェック用レスポンス
 *
 * @generated from message api_proto.v1.CheckMaskImagesReadyResponse
 */
export type CheckMaskImagesReadyResponse = Message<"api_proto.v1.CheckMaskImagesReadyResponse"> & {
  /**
   * true = 指定画像に対してマスク生成完了（MASKED_WALL、MASKED_ROOF、MASKED_GUTTERの全てが存在。fasciaは後方互換のため判定に含めない）
   *
   * @generated from field: bool is_ready = 1;
   */
  isReady: boolean;

  /**
   * MASKED_WALL（type=4）が存在するか
   *
   * @generated from field: bool has_wall_mask = 2;
   */
  hasWallMask: boolean;

  /**
   * MASKED_ROOF（type=5）が存在するか
   *
   * @generated from field: bool has_roof_mask = 3;
   */
  hasRoofMask: boolean;

  /**
   * MASKED_GUTTER（type=6）が存在するか
   *
   * @generated from field: bool has_gutter_mask = 4;
   */
  hasGutterMask: boolean;

  /**
   * MASKED_FASCIA（type=7）が存在するか
   *
   * @generated from field: bool has_fascia_mask = 5;
   */
  hasFasciaMask: boolean;
};

/**
 * Describes the message api_proto.v1.CheckMaskImagesReadyResponse.
 * Use `create(CheckMaskImagesReadyResponseSchema)` to create a new message.
 */
export const CheckMaskImagesReadyResponseSchema: GenMessage<CheckMaskImagesReadyResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 5);

/**
 * 画像のお気に入り状態を更新する
 *
 * @generated from message api_proto.v1.ToggleColorSimulationImageFavoriteRequest
 */
export type ToggleColorSimulationImageFavoriteRequest = Message<"api_proto.v1.ToggleColorSimulationImageFavoriteRequest"> & {
  /**
   * @generated from field: int64 image_id = 1;
   */
  imageId: bigint;

  /**
   * @generated from field: bool favorited = 2;
   */
  favorited: boolean;
};

/**
 * Describes the message api_proto.v1.ToggleColorSimulationImageFavoriteRequest.
 * Use `create(ToggleColorSimulationImageFavoriteRequestSchema)` to create a new message.
 */
export const ToggleColorSimulationImageFavoriteRequestSchema: GenMessage<ToggleColorSimulationImageFavoriteRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 6);

/**
 * @generated from message api_proto.v1.ToggleColorSimulationImageFavoriteResponse
 */
export type ToggleColorSimulationImageFavoriteResponse = Message<"api_proto.v1.ToggleColorSimulationImageFavoriteResponse"> & {
  /**
   * @generated from field: bool favorited = 1;
   */
  favorited: boolean;
};

/**
 * Describes the message api_proto.v1.ToggleColorSimulationImageFavoriteResponse.
 * Use `create(ToggleColorSimulationImageFavoriteResponseSchema)` to create a new message.
 */
export const ToggleColorSimulationImageFavoriteResponseSchema: GenMessage<ToggleColorSimulationImageFavoriteResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 7);

/**
 * シミュレーション結果画像を削除する
 *
 * @generated from message api_proto.v1.DeleteColorSimulationImageRequest
 */
export type DeleteColorSimulationImageRequest = Message<"api_proto.v1.DeleteColorSimulationImageRequest"> & {
  /**
   * @generated from field: int64 image_id = 1;
   */
  imageId: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteColorSimulationImageRequest.
 * Use `create(DeleteColorSimulationImageRequestSchema)` to create a new message.
 */
export const DeleteColorSimulationImageRequestSchema: GenMessage<DeleteColorSimulationImageRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 8);

/**
 * 履歴（生成画像）のタイトルを更新する（企業・施主で共通。施主は共有リンクの範囲内の履歴だけ）
 *
 * @generated from message api_proto.v1.UpdateColorSimulationImageTitleRequest
 */
export type UpdateColorSimulationImageTitleRequest = Message<"api_proto.v1.UpdateColorSimulationImageTitleRequest"> & {
  /**
   * @generated from field: int64 image_id = 1;
   */
  imageId: bigint;

  /**
   * 30文字まで。前後の空白を除いて空なら未設定に戻す。改行は不可
   *
   * @generated from field: string title = 2;
   */
  title: string;
};

/**
 * Describes the message api_proto.v1.UpdateColorSimulationImageTitleRequest.
 * Use `create(UpdateColorSimulationImageTitleRequestSchema)` to create a new message.
 */
export const UpdateColorSimulationImageTitleRequestSchema: GenMessage<UpdateColorSimulationImageTitleRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 9);

/**
 * @generated from message api_proto.v1.UpdateColorSimulationImageTitleResponse
 */
export type UpdateColorSimulationImageTitleResponse = Message<"api_proto.v1.UpdateColorSimulationImageTitleResponse"> & {
  /**
   * 保存後のタイトル（未設定は空文字列）
   *
   * @generated from field: string title = 1;
   */
  title: string;
};

/**
 * Describes the message api_proto.v1.UpdateColorSimulationImageTitleResponse.
 * Use `create(UpdateColorSimulationImageTitleResponseSchema)` to create a new message.
 */
export const UpdateColorSimulationImageTitleResponseSchema: GenMessage<UpdateColorSimulationImageTitleResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 10);

/**
 * 履歴（生成画像）のピン留めを設定・解除する（企業のみ）。1プロジェクト4件まで
 *
 * @generated from message api_proto.v1.UpdateColorSimulationImagePinRequest
 */
export type UpdateColorSimulationImagePinRequest = Message<"api_proto.v1.UpdateColorSimulationImagePinRequest"> & {
  /**
   * @generated from field: int64 image_id = 1;
   */
  imageId: bigint;

  /**
   * @generated from field: bool pinned = 2;
   */
  pinned: boolean;

  /**
   * pinned=true で上限（4件）に達しているとき、代わりに外すピン留め済みの履歴ID。
   * 0 で上限なら AI_COLOR_PIN_LIMIT_EXCEEDED（FailedPrecondition）。外す・付けるは同じトランザクションで行う
   *
   * @generated from field: int64 replace_image_id = 3;
   */
  replaceImageId: bigint;
};

/**
 * Describes the message api_proto.v1.UpdateColorSimulationImagePinRequest.
 * Use `create(UpdateColorSimulationImagePinRequestSchema)` to create a new message.
 */
export const UpdateColorSimulationImagePinRequestSchema: GenMessage<UpdateColorSimulationImagePinRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 11);

/**
 * @generated from message api_proto.v1.UpdateColorSimulationImagePinResponse
 */
export type UpdateColorSimulationImagePinResponse = Message<"api_proto.v1.UpdateColorSimulationImagePinResponse"> & {
  /**
   * 設定後のピン留め日時（解除なら未設定）
   *
   * @generated from field: google.protobuf.Timestamp pinned_at = 1;
   */
  pinnedAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.UpdateColorSimulationImagePinResponse.
 * Use `create(UpdateColorSimulationImagePinResponseSchema)` to create a new message.
 */
export const UpdateColorSimulationImagePinResponseSchema: GenMessage<UpdateColorSimulationImagePinResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 12);

/**
 * 共有リンクを作成する
 *
 * @generated from message api_proto.v1.CreateColorSimulationShareLinkRequest
 */
export type CreateColorSimulationShareLinkRequest = Message<"api_proto.v1.CreateColorSimulationShareLinkRequest"> & {
  /**
   * @generated from field: int64 deal_id = 1;
   */
  dealId: bigint;

  /**
   * @generated from field: int64 base_image_id = 2;
   */
  baseImageId: bigint;

  /**
   * @generated from field: ai_color_simulation.v1.ProcessImageParameters parameters = 3;
   */
  parameters?: ProcessImageParameters;

  /**
   * deal非依存フロー(issue #1828)。deal_id と排他。ULID
   *
   * @generated from field: string ai_color_project_id = 4;
   */
  aiColorProjectId: string;

  /**
   * エリア別プリセット選択（施主に提示する色をエリアごとに絞り込む）
   *
   * @generated from field: api_proto.v1.AreaPresetSelection area_preset_selection = 5;
   */
  areaPresetSelection?: AreaPresetSelection;

  /**
   * 施主が着地する履歴（生成画像）のID。0=プロジェクト単位（従来どおり最新の履歴に着地）。
   * 指定時は base_image_id と parameters をサーバーがこの履歴から導く（要求の値は使わない）
   *
   * @generated from field: int64 anchor_image_id = 6;
   */
  anchorImageId: bigint;
};

/**
 * Describes the message api_proto.v1.CreateColorSimulationShareLinkRequest.
 * Use `create(CreateColorSimulationShareLinkRequestSchema)` to create a new message.
 */
export const CreateColorSimulationShareLinkRequestSchema: GenMessage<CreateColorSimulationShareLinkRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 13);

/**
 * @generated from message api_proto.v1.CreateColorSimulationShareLinkResponse
 */
export type CreateColorSimulationShareLinkResponse = Message<"api_proto.v1.CreateColorSimulationShareLinkResponse"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message api_proto.v1.CreateColorSimulationShareLinkResponse.
 * Use `create(CreateColorSimulationShareLinkResponseSchema)` to create a new message.
 */
export const CreateColorSimulationShareLinkResponseSchema: GenMessage<CreateColorSimulationShareLinkResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 14);

/**
 * AIカラーシミュレーションプロジェクト（deal非依存。issue #1828）
 *
 * @generated from message api_proto.v1.AiColorProject
 */
export type AiColorProject = Message<"api_proto.v1.AiColorProject"> & {
  /**
   * ULID (Crockford base32、26文字)。AUTO_INCREMENTは使わない
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 company_id = 2;
   */
  companyId: bigint;

  /**
   * 後方互換: deal起点で作成された場合のみ非0。案件連携時にセット
   *
   * @generated from field: int64 deal_id = 3;
   */
  dealId: bigint;

  /**
   * プロジェクト名
   *
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * 作成スタッフID（未設定時は0）
   *
   * @generated from field: int64 created_by_staff_id = 5;
   */
  createdByStaffId: bigint;

  /**
   * 紐付け顧客ID（未設定時は0）
   *
   * @generated from field: int64 customer_id = 6;
   */
  customerId: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created = 7;
   */
  created?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated = 8;
   */
  updated?: Timestamp;

  /**
   * 作成（アップロード起点）スタッフ名（未設定時は空）。issue #2287 フィードバック
   *
   * @generated from field: string created_by_name = 9;
   */
  createdByName: string;
};

/**
 * Describes the message api_proto.v1.AiColorProject.
 * Use `create(AiColorProjectSchema)` to create a new message.
 */
export const AiColorProjectSchema: GenMessage<AiColorProject> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 15);

/**
 * deal を作成せず ai_color_projects レコードを作成する
 *
 * @generated from message api_proto.v1.CreateAiColorProjectRequest
 */
export type CreateAiColorProjectRequest = Message<"api_proto.v1.CreateAiColorProjectRequest"> & {
  /**
   * プロジェクト名（空入力時はサーバ側で「未設定 (日時)」を採用）
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 既存顧客をアサイン（0=なし）。優先される
   *
   * @generated from field: int64 customer_id = 2;
   */
  customerId: bigint;

  /**
   * customer_id==0 かつ非空なら新規顧客を作成して紐付け
   *
   * @generated from field: string new_customer_name = 3;
   */
  newCustomerName: string;
};

/**
 * Describes the message api_proto.v1.CreateAiColorProjectRequest.
 * Use `create(CreateAiColorProjectRequestSchema)` to create a new message.
 */
export const CreateAiColorProjectRequestSchema: GenMessage<CreateAiColorProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 16);

/**
 * @generated from message api_proto.v1.CreateAiColorProjectResponse
 */
export type CreateAiColorProjectResponse = Message<"api_proto.v1.CreateAiColorProjectResponse"> & {
  /**
   * @generated from field: api_proto.v1.AiColorProject project = 1;
   */
  project?: AiColorProject;
};

/**
 * Describes the message api_proto.v1.CreateAiColorProjectResponse.
 * Use `create(CreateAiColorProjectResponseSchema)` to create a new message.
 */
export const CreateAiColorProjectResponseSchema: GenMessage<CreateAiColorProjectResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 17);

/**
 * AIカラープロジェクト（deal非依存）の詳細＋画像一覧を取得する (issue #1828)
 *
 * @generated from message api_proto.v1.GetAiColorProjectRequest
 */
export type GetAiColorProjectRequest = Message<"api_proto.v1.GetAiColorProjectRequest"> & {
  /**
   * ai_color_projects.id (ULID)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message api_proto.v1.GetAiColorProjectRequest.
 * Use `create(GetAiColorProjectRequestSchema)` to create a new message.
 */
export const GetAiColorProjectRequestSchema: GenMessage<GetAiColorProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 18);

/**
 * @generated from message api_proto.v1.GetAiColorProjectResponse
 */
export type GetAiColorProjectResponse = Message<"api_proto.v1.GetAiColorProjectResponse"> & {
  /**
   * @generated from field: api_proto.v1.AiColorProject project = 1;
   */
  project?: AiColorProject;

  /**
   * @generated from field: repeated api_proto.v1.OriginalColorSimulationImages images = 2;
   */
  images: OriginalColorSimulationImages[];
};

/**
 * Describes the message api_proto.v1.GetAiColorProjectResponse.
 * Use `create(GetAiColorProjectResponseSchema)` to create a new message.
 */
export const GetAiColorProjectResponseSchema: GenMessage<GetAiColorProjectResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 19);

/**
 * AIカラープロジェクト名を更新する
 *
 * @generated from message api_proto.v1.UpdateAiColorProjectNameRequest
 */
export type UpdateAiColorProjectNameRequest = Message<"api_proto.v1.UpdateAiColorProjectNameRequest"> & {
  /**
   * ai_color_projects.id (ULID)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message api_proto.v1.UpdateAiColorProjectNameRequest.
 * Use `create(UpdateAiColorProjectNameRequestSchema)` to create a new message.
 */
export const UpdateAiColorProjectNameRequestSchema: GenMessage<UpdateAiColorProjectNameRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 20);

/**
 * @generated from message api_proto.v1.UpdateAiColorProjectNameResponse
 */
export type UpdateAiColorProjectNameResponse = Message<"api_proto.v1.UpdateAiColorProjectNameResponse"> & {
  /**
   * @generated from field: api_proto.v1.AiColorProject project = 1;
   */
  project?: AiColorProject;
};

/**
 * Describes the message api_proto.v1.UpdateAiColorProjectNameResponse.
 * Use `create(UpdateAiColorProjectNameResponseSchema)` to create a new message.
 */
export const UpdateAiColorProjectNameResponseSchema: GenMessage<UpdateAiColorProjectNameResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 21);

/**
 * AIカラープロジェクトの顧客を変更/アサインする（案件連携の前提。issue #1828 follow-up）
 * customer_id 優先 → 空かつ new_customer_name 非空なら新規作成 → どちらも空ならクリア(NULL)。
 * 案件連携中(deal_id あり)は変更不可（先に連携解除が必要）。
 *
 * @generated from message api_proto.v1.UpdateAiColorProjectCustomerRequest
 */
export type UpdateAiColorProjectCustomerRequest = Message<"api_proto.v1.UpdateAiColorProjectCustomerRequest"> & {
  /**
   * ai_color_projects.id (ULID)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 既存顧客をアサイン（0=未指定）
   *
   * @generated from field: int64 customer_id = 2;
   */
  customerId: bigint;

  /**
   * customer_id==0 かつ非空なら新規顧客を作成して紐付け（空ならクリア）
   *
   * @generated from field: string new_customer_name = 3;
   */
  newCustomerName: string;
};

/**
 * Describes the message api_proto.v1.UpdateAiColorProjectCustomerRequest.
 * Use `create(UpdateAiColorProjectCustomerRequestSchema)` to create a new message.
 */
export const UpdateAiColorProjectCustomerRequestSchema: GenMessage<UpdateAiColorProjectCustomerRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 22);

/**
 * @generated from message api_proto.v1.UpdateAiColorProjectCustomerResponse
 */
export type UpdateAiColorProjectCustomerResponse = Message<"api_proto.v1.UpdateAiColorProjectCustomerResponse"> & {
  /**
   * @generated from field: api_proto.v1.AiColorProject project = 1;
   */
  project?: AiColorProject;
};

/**
 * Describes the message api_proto.v1.UpdateAiColorProjectCustomerResponse.
 * Use `create(UpdateAiColorProjectCustomerResponseSchema)` to create a new message.
 */
export const UpdateAiColorProjectCustomerResponseSchema: GenMessage<UpdateAiColorProjectCustomerResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 23);

/**
 * AIカラープロジェクト一覧の 1 項目（deal非依存の正式な一覧。issue #1828 follow-up）
 *
 * @generated from message api_proto.v1.AiColorProjectListItem
 */
export type AiColorProjectListItem = Message<"api_proto.v1.AiColorProjectListItem"> & {
  /**
   * @generated from field: api_proto.v1.AiColorProject project = 1;
   */
  project?: AiColorProject;

  /**
   * 紐付け顧客名（未設定時は空）
   *
   * @generated from field: string customer_name = 2;
   */
  customerName: string;

  /**
   * サムネイル用。最新の可視シミュレーション画像、無ければ最新の原画像の presigned URL
   *
   * @generated from field: string latest_image_url = 3;
   */
  latestImageUrl: string;

  /**
   * 原画像（アップロード）枚数
   *
   * @generated from field: int32 uploaded_count = 4;
   */
  uploadedCount: number;

  /**
   * シミュレーション結果画像枚数
   *
   * @generated from field: int32 processed_count = 5;
   */
  processedCount: number;

  /**
   * 作成（アップロード起点）スタッフ名。未設定時は空。issue #2228
   *
   * @generated from field: string created_by_name = 6;
   */
  createdByName: string;
};

/**
 * Describes the message api_proto.v1.AiColorProjectListItem.
 * Use `create(AiColorProjectListItemSchema)` to create a new message.
 */
export const AiColorProjectListItemSchema: GenMessage<AiColorProjectListItem> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 24);

/**
 * AIカラープロジェクト一覧を取得する（deal非依存）
 *
 * @generated from message api_proto.v1.ListAiColorProjectsRequest
 */
export type ListAiColorProjectsRequest = Message<"api_proto.v1.ListAiColorProjectsRequest"> & {
  /**
   * 1始まり
   *
   * @generated from field: int64 page = 1;
   */
  page: bigint;

  /**
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;

  /**
   * プロジェクト名・顧客名の部分一致
   *
   * @generated from field: string free_word = 3;
   */
  freeWord: string;

  /**
   * 顧客で絞り込む（0=絞り込まない）
   *
   * @generated from field: int64 customer_id = 4;
   */
  customerId: bigint;

  /**
   * 担当者（作成スタッフ）で絞り込む（0=絞り込まない）。issue #2227
   *
   * @generated from field: int64 created_by_staff_id = 5;
   */
  createdByStaffId: bigint;

  /**
   * 作成日時の下限（含む）。未設定=絞り込まない。issue #2227
   *
   * @generated from field: google.protobuf.Timestamp created_from = 6;
   */
  createdFrom?: Timestamp;

  /**
   * 作成日時の上限（含む）。未設定=絞り込まない。issue #2227
   *
   * @generated from field: google.protobuf.Timestamp created_to = 7;
   */
  createdTo?: Timestamp;
};

/**
 * Describes the message api_proto.v1.ListAiColorProjectsRequest.
 * Use `create(ListAiColorProjectsRequestSchema)` to create a new message.
 */
export const ListAiColorProjectsRequestSchema: GenMessage<ListAiColorProjectsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 25);

/**
 * @generated from message api_proto.v1.ListAiColorProjectsResponse
 */
export type ListAiColorProjectsResponse = Message<"api_proto.v1.ListAiColorProjectsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.AiColorProjectListItem items = 1;
   */
  items: AiColorProjectListItem[];

  /**
   * @generated from field: int64 total_page = 2;
   */
  totalPage: bigint;

  /**
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;
};

/**
 * Describes the message api_proto.v1.ListAiColorProjectsResponse.
 * Use `create(ListAiColorProjectsResponseSchema)` to create a new message.
 */
export const ListAiColorProjectsResponseSchema: GenMessage<ListAiColorProjectsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 26);

/**
 * 案件を AIカラープロジェクトに連携する（ai_color_projects.deal_id をセット）
 *
 * @generated from message api_proto.v1.LinkDealToAiColorProjectRequest
 */
export type LinkDealToAiColorProjectRequest = Message<"api_proto.v1.LinkDealToAiColorProjectRequest"> & {
  /**
   * ai_color_projects.id (ULID)
   *
   * @generated from field: string ai_color_project_id = 1;
   */
  aiColorProjectId: string;

  /**
   * @generated from field: int64 deal_id = 2;
   */
  dealId: bigint;
};

/**
 * Describes the message api_proto.v1.LinkDealToAiColorProjectRequest.
 * Use `create(LinkDealToAiColorProjectRequestSchema)` to create a new message.
 */
export const LinkDealToAiColorProjectRequestSchema: GenMessage<LinkDealToAiColorProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 27);

/**
 * @generated from message api_proto.v1.LinkDealToAiColorProjectResponse
 */
export type LinkDealToAiColorProjectResponse = Message<"api_proto.v1.LinkDealToAiColorProjectResponse"> & {
  /**
   * @generated from field: api_proto.v1.AiColorProject project = 1;
   */
  project?: AiColorProject;
};

/**
 * Describes the message api_proto.v1.LinkDealToAiColorProjectResponse.
 * Use `create(LinkDealToAiColorProjectResponseSchema)` to create a new message.
 */
export const LinkDealToAiColorProjectResponseSchema: GenMessage<LinkDealToAiColorProjectResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 28);

/**
 * AIカラープロジェクトから案件連携を解除する（ai_color_projects.deal_id を NULL に）
 *
 * @generated from message api_proto.v1.UnlinkDealFromAiColorProjectRequest
 */
export type UnlinkDealFromAiColorProjectRequest = Message<"api_proto.v1.UnlinkDealFromAiColorProjectRequest"> & {
  /**
   * ai_color_projects.id (ULID)
   *
   * @generated from field: string ai_color_project_id = 1;
   */
  aiColorProjectId: string;
};

/**
 * Describes the message api_proto.v1.UnlinkDealFromAiColorProjectRequest.
 * Use `create(UnlinkDealFromAiColorProjectRequestSchema)` to create a new message.
 */
export const UnlinkDealFromAiColorProjectRequestSchema: GenMessage<UnlinkDealFromAiColorProjectRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 29);

/**
 * @generated from message api_proto.v1.UnlinkDealFromAiColorProjectResponse
 */
export type UnlinkDealFromAiColorProjectResponse = Message<"api_proto.v1.UnlinkDealFromAiColorProjectResponse"> & {
  /**
   * @generated from field: api_proto.v1.AiColorProject project = 1;
   */
  project?: AiColorProject;
};

/**
 * Describes the message api_proto.v1.UnlinkDealFromAiColorProjectResponse.
 * Use `create(UnlinkDealFromAiColorProjectResponseSchema)` to create a new message.
 */
export const UnlinkDealFromAiColorProjectResponseSchema: GenMessage<UnlinkDealFromAiColorProjectResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_ai_color_simulation, 30);

/**
 * 画像の作成者種別
 *
 * @generated from enum api_proto.v1.ColorSimulationImageCreatedByType
 */
export enum ColorSimulationImageCreatedByType {
  /**
   * 未指定
   *
   * @generated from enum value: COLOR_SIMULATION_IMAGE_CREATED_BY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * スタッフ作成
   *
   * @generated from enum value: COLOR_SIMULATION_IMAGE_CREATED_BY_TYPE_STAFF = 1;
   */
  STAFF = 1,

  /**
   * 施主作成
   *
   * @generated from enum value: COLOR_SIMULATION_IMAGE_CREATED_BY_TYPE_CUSTOMER = 2;
   */
  CUSTOMER = 2,
}

/**
 * Describes the enum api_proto.v1.ColorSimulationImageCreatedByType.
 */
export const ColorSimulationImageCreatedByTypeSchema: GenEnum<ColorSimulationImageCreatedByType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_ai_color_simulation, 0);

